import { inject, Injectable } from "@angular/core";
import { AuditApi } from "../Api/AuditApi";
import { AuditState } from "./AuditState";
import { AuditWithSession } from "../Dto/AuditModel";
import { SearchAuditRequest } from "../Dto/SearchAuditRequest";
import { getBackendErrorMessage } from "../../../Common/Utility/UtilityError";

@Injectable({ providedIn: "root" })
export class AuditEffects {
  private readonly auditApi = inject(AuditApi);
  private readonly auditState = inject(AuditState);

  async searchAudits(params: SearchAuditRequest = {}): Promise<void> {
    const mergedParams: SearchAuditRequest = {
      ...this.auditState.searchParams(),
      ...params,
    };

    this.auditState.setLoading(true);
    this.auditState.setError(null);

    try {
      const response = await this.auditApi.searchAudits(mergedParams);
      this.auditState.setAudits(response.data, response.pagination);
      this.auditState.setSearchParams(mergedParams);
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception);
      this.auditState.setError(errorMessage);
    } finally {
      this.auditState.setLoading(false);
    }
  }

  async getAuditById(id: string): Promise<AuditWithSession | null> {
    this.auditState.setLoading(true);
    this.auditState.setError(null);

    try {
      const audit = await this.auditApi.getAuditById(id);
      return audit;
    } catch (exception: unknown) {
      const errorMessage = getBackendErrorMessage(exception);
      this.auditState.setError(errorMessage);
      return null;
    } finally {
      this.auditState.setLoading(false);
    }
  }
}
